import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import {ExportFieldEditComponent} from '../../components/Exports/ExportFieldEdit.component';


@Component({
  selector: 'my-export-field-grid',
  templateUrl: './ExportFieldGrid.component.html'
})
export class ExportFieldGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(ExportFieldEditComponent) recordEditComponent: ExportFieldEditComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    records: ent.ExportField[];
    editedRecord: ent.ExportField;
    cols: any[];

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private exportService: serv.ExportService) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }
        this.editedRecord = new ent.ExportField();
        this.recordEditComponent.fieldTypeDropdownComponent.load();
        this.userInfo = this.authenticationService.getUserInfo();
        this.loadColumns();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'Header', header: 'Header' },
            { field: 'CONAHeader', header: 'CONAHeader' },
            { field: 'FieldType.Name', header: 'Field Type' },
            { field: 'FieldName', header: 'FieldName' },
            { field: 'Value', header: 'Value' },
            { field: 'EquipmentSequenceOverride', header: 'Equipment Sequence Override' },
        ];

    }

    onAddClick(event: any){
        this.editedRecord = new ent.ExportField();
        this.recordEditComponent.fieldTypeDropdownComponent.value = null;
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, record: ent.ExportField){
        this.editedRecord = record;
        this.recordEditComponent.fieldTypeDropdownComponent.value = record.FieldTypeID;
        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveExportFieldRequest = {ExportField: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.exportService.saveExportField(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        this.exportService.getExportFields().subscribe(x=> {
            this.records = x;
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }
    

    
    
}